import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Icon } from 'oxyrion-ui/lib';
import { rem } from 'polished';
import baseTheme from 'oxyrion-ui/lib/Themes/baseTheme';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  background-color: #f7f7f7;
  border-radius: ${rem(4)};
  width: calc(100% - 40px);
  padding: ${rem(20)};
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex;
  width: ${rem(250)} ;
  height: ${rem(64)};
  // margin: ${rem(16)};
`;
const IconWrapper = styled.div``;

const TitleWrapper = styled.div`
  padding-left: ${rem(10)};
  font-size: ${rem(24)};
`;

export default class ToningCard extends React.Component {
  render() {
    return (
      <Wrapper>
        <Header>
          <IconWrapper>
            <Icon
              name={this.props.icon}
              color={baseTheme.color.primary}
              size="xl"
            />
          </IconWrapper>
          <TitleWrapper>{this.props.title}</TitleWrapper>
        </Header>
        {this.props.children}
      </Wrapper>
    );
  }
}

ToningCard.propTypes = {
  children: PropTypes.element.isRequired,
  title: PropTypes.string,
  icon: PropTypes.string,
};

ToningCard.defaultProps = {
  title: '',
  icon: '',
};



// WEBPACK FOOTER //
// ./src/Components/ToningCard/index.jsx